import { StyledButton } from 'components/shared/Button/styles';
import styled from 'styled-components';

export const StyledAdminEditInput = styled.div`
  ${StyledButton} {
    font-weight: 700;
    line-height: 150%;

    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }

    @media (min-width: 768px) and (max-width: 1440px) {
      padding: 0.8rem 1.6rem;
      font-size: 1.4rem;
    }

    @media (min-width: 1440px) and (max-width: 2118px) {
      padding: 1.3rem 2.8rem;
      font-size: 1.8rem;
    }

    @media screen and (min-width: 2118px) {
      padding: 1.3rem 2.8rem;
      font-size: 1.8rem;
    }
  }

  .form {
    display: flex;
    gap: 0.8rem;

    @media screen and (min-width: 1440px) {
      align-items: center;
      gap: 1.4rem;
    }

    .input-group {
      flex-grow: 1;
      position: relative;
      @media screen and (min-width: 1024px) {
        max-width: 37rem;
      }
      @media screen and (min-width: 1920px) {
        max-width: 30vw;
      }
    }
    .input {
      display: block;
      width: 100%;
      height: 100%;

      border-radius: 6px;

      padding: 1.6rem;
      padding-right: 4rem;
      font-feature-settings:
        'clig' off,
        'liga' off;
      font-size: 1.6rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;

      &[type='number'] {
        -webkit-appearance: textfield;
        -moz-appearance: textfield;
        appearance: textfield;
      }
      &[type='number']::-webkit-inner-spin-button,
      &[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
      }

      @media screen and (max-width: 768px) {
        padding: 1rem;
        font-size: 1.2rem;
        line-height: normal;
      }

      @media (min-width: 768px) and (max-width: 1440px) {
        font-size: 1.4rem;
        line-height: normal;
        padding: 1.1rem 3.8rem 1.1rem 1.1rem;
      }
    }
    .number-adjust {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);

      right: 0;
      padding: 1px 8px;

      &-button {
        display: block;
        color: ${(props) => props.theme.button3};

        &:hover {
          color: ${(props) =>
            props.theme.id === 'dark' ? props.theme.button1 : props.theme.text2};
        }

        &-icon {
          *[stroke] {
            stroke: currentColor;
          }

          @media screen and (max-width: 1200px) {
            width: 1.2rem;
            height: 1.2rem;
          }
        }
      }
    }
  }
`;
